module.exports = "/images/vendor/lightbox2/dist/close.png?d9d2d0b1308cb694aa8116915592e2a9";